module.exports = __webpack_public_path__ + "static/media/profesor informacion general.1b41d955.svg";